const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_da_part2 = {
  bannerScheduleWeeklyHint:
    "Hvis sluttid er tidligere end starttid, krydser vinduet midnat (fx 17:00–07:00).",
  bannerScheduleFixedHint:
    "Gemmes som absolutte tidspunkter. Ryd et felt for at lade det være åbent.",
  bannerScheduleEndIn3Days: "Slut om 3 dage",
  bannerWeekday0: "Søn",
  bannerWeekday1: "Man",
  bannerWeekday2: "Tir",
  bannerWeekday3: "Ons",
  bannerWeekday4: "Tor",
  bannerWeekday5: "Fre",
  bannerWeekday6: "Lør",
  // Missing Info Tickets
  // Missing Info Tickets
  missingInfoTickets: "Manglende Info",
  missingInfoTicketsTitle: "Manglende Information Tickets",
  missingInfoTicketsDescription: "AI-drevne forslag til indhold du kan uploade til din chatbot",
  generateTickets: "Generer Tickets",
  generating: "Genererer...",
  selectLanguageOption: "Vælg sprog",
  selectTicketTranslationLanguage: "Vælg sprog til oversættelse af tickets",
  translateTickets: "Oversæt",
  translatingTickets: "Oversætter...",
  analyzingConversations: "Analyserer samtaler og genererer tickets...",
  generatedTickets: "Genererede {count} nye tickets!",
  noNewTicketsGenerated: "Ingen nye tickets genereret",
  howItWorks: "Sådan virker det:",
  howItWorksDescription:
    'Hver mandag analyserer AI automatisk dine seneste samtaler markeret med "manglende info" og opretter tickets for de mest almindelige spørgsmål. Du kan også manuelt starte ticket-generering når som helst.',
  pending: "Afventer",
  uploaded: "Uploadet",
  rejected: "Afvist",
  expired: "Udløbet",
  noChatbotSelected: "Ingen chatbot valgt",
  selectChatbotMessage: "Vælg venligst en chatbot fra dropdown-menuen ovenfor for at se tickets.",
  noTicketsFound: "Ingen tickets fundet",
  generateTicketsPrompt: "Generer tickets for at få AI-drevne forslag til manglende information",
  noTicketsWithStatus: "Ingen tickets med denne status",
  priority: "Prioritet",
  deleteTicket: "Slet ticket",
  uploadInfo: "Upload Info",
  reject: "Afvis",
  uploadInformation: "Upload Information",
  titleLabel: "Titel",
  titlePlaceholder: "Titel til denne information",
  informationLabel: "Information",
  informationPlaceholder: "Indtast informationen der besvarer dette spørgsmål...",
  questionLabel: "Spørgsmål:",
  autoDeleteOptional: "Automatisk sletning (valgfri)",
  selectAutoDeleteDate: "Vælg dato og tid",
  clearDate: "Ryd dato",
  autoDeleteTooltip: "Indholdet slettes automatisk på det valgte tidspunkt",
  selectIndexFirst: "Vælg venligst en vidensdatabase først",
  ticketRejected: "Ticket afvist",
  ticketDeleted: "Ticket slettet",
  infoUploadedSuccess: "Information uploadet succesfuldt!",
  uploadSuccessSummaryLabel: "Oversigt",
  uploadSuccessOk: "Luk",
  enterInfoToUpload: "Indtast venligst informationen der skal uploades",
  failedToFetchTickets: "Kunne ikke hente tickets",
  failedToGenerateTickets: "Kunne ikke generere tickets",
  failedToRejectTicket: "Kunne ikke afvise ticket",
  failedToDeleteTicket: "Kunne ikke slette ticket",
  failedToTranslateTickets: "Kunne ikke oversætte tickets",
  failedToUploadInfo: "Kunne ikke uploade information",
  basedOnConversations: "Baseret på {count} samtale(r)",
  viewConversation: "Se samtale",
  relatedConversations: "Relaterede samtaler",
  noRelatedConversations: "Ingen relaterede samtaler",
  more: "mere",
  // AI Help translations
  // AI Help translations
  aiHelp: "AI Hjælp",
  aiHelpComingSoon: "AI Hjælp funktionalitet kommer snart!",
  aiHelpDescription: 'Klik "Kør Analyse" for at få AI-drevne indsigter om dine info chunks',
  analyzingYourData: "Analyserer dine data...",
  backToUpload: "Tilbage til Upload Data",
  searchPlaceholder: "Søg i dine info chunks...",
  resultsFound: "resultater fundet",
  clearHighlightedItems: "Ryd Fremhævede Elementer",
  showMore: "Vis mere",
  showLess: "Vis mindre",
  confidence: "Sikkerhed",
  show: "Vis",
  loading: "Indlæser...",
  suggestMerge: "Foreslå Sammenlægning",
  mergeSuggestion: "Sammenlægnings Forslag",
  originalEntries: "Oprindelige Poster",
  entry: "Post",
  suggestedMergedEntry: "Foreslået Sammenlagt Post",
  aiExplanation: "AI Forklaring:",
  applyMerge: "Anvend Sammenlægning",
  applying: "Anvender...",
  [duplicateTranslationKey("cancel")]: "Annuller",
  generateImprovementSuggestions: "Generer Forbedringsforslag",
  [duplicateTranslationKey("generating")]: "Genererer...",
  hideAIRecommendations: "Skjul AI-Genererede Forbedringsanbefalinger",
  showAIRecommendations: "Vis AI-Genererede Forbedringsanbefalinger",
  affectedItems: "Berørte elementer:",
  moreItems: "flere elementer",
  current: "Nuværende:",
  improved: "Forbedret:",
  suggestion: "Forslag:",
  applyThisSuggestion: "Anvend Dette Forslag",
  identicalTitles: "Identiske titler i samme videnbase",
  similarTitlesContent: "Meget lignende titler og relateret indhold",
  similarContent: "Meget lignende indhold i samme videnbase",
  applyingChanges: "Anvender...",
  refineWithFeedback: "Forfin med feedback",
  refinePlaceholder:
    "Skriv kort feedback til AI (fx kortere, venligere tone, inkluder åbningstider...)",
  refineSuggestion: "Forfin forslag",
  suggestionRefined: "Forslag forfinet!",
  failedToRefine: "Kunne ikke forfine forslag",
  // Recommendation types (Danish)
  // Recommendation types (Danish)
  weakOrIncompleteContent: "Svagt eller Ufuldstændigt Indhold",
  weakContentDesc:
    "elementer virker ufuldstændige eller dårligt formulerede. Tilføj manglende detaljer og forbedre klarheden.",
  unclearOrVaguePrompts: "Uklare eller Vage Prompts",
  unclearPromptsDesc:
    "prompts kunne være mere specifikke. Overvej at tilføje mere kontekst og klare instruktioner.",
  missingClearCTA: "Gør Opfordringen til Handling Klarere",
  missingCTADesc:
    "prompts mangler en klarere handling. Tilføj specifikke næste skridt for brugere.",
};
